import React from 'react';
import { CreditCard, Banknote, Building2 } from 'lucide-react';

const Pagamenti = () => (
  <div className="max-w-4xl mx-auto px-4 lg:px-6 py-10 fade-in">
    <div className="flex items-center gap-3 mb-2">
      <CreditCard className="text-[#d62828]" size={28} />
      <h1 className="text-4xl font-black brand-text text-neutral-900">Modalità di Pagamento</h1>
    </div>
    <p className="text-neutral-600 max-w-2xl">
      Accettiamo varie forme di pagamento per garantire la massima flessibilità ai nostri clienti professionali.
    </p>

    <div className="mt-8 grid md:grid-cols-3 gap-5">
      <Card icon={<Building2 />} title="Bonifico Bancario" desc="Pagamento anticipato, vista fattura, a 30/60 gg per clienti con partita IVA. IBAN nei dati fiscali." />
      <Card icon={<CreditCard />} title="Carta di Credito" desc="Visa, Mastercard, American Express. Possibilità di garanzia / pre-autorizzazione." />
      <Card icon={<Banknote />} title="Contanti" desc="Accettati in sede entro i limiti di legge per i piccoli noleggi giornalieri." />
    </div>

    <div className="mt-10 p-6 bg-neutral-50 rounded-lg border border-neutral-200">
      <h3 className="font-bold text-neutral-800 mb-2">Cauzione</h3>
      <p className="text-neutral-700 text-sm">
        Per prodotti di alto valore, potrebbe essere richiesta una cauzione tramite carta di credito o bonifico, restituita al rientro dell'attrezzatura in perfette condizioni.
      </p>
    </div>
  </div>
);

const Card = ({ icon, title, desc }) => (
  <div className="p-6 bg-white border border-neutral-200 rounded-lg hover:shadow-md hover:border-[#d62828]/30 transition-all">
    <div className="w-12 h-12 rounded-full bg-[#d62828]/10 text-[#d62828] flex items-center justify-center mb-3">{icon}</div>
    <h3 className="font-bold text-neutral-800">{title}</h3>
    <p className="text-sm text-neutral-600 mt-2">{desc}</p>
  </div>
);

export default Pagamenti;
